import React, {
  useLayoutEffect,
  useEffect,
  useState,
  useCallback,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import IsLoading from "../components/IsLoading";
import HasError from "../components/HasError";
import { useSelector } from "react-redux";
import BarChartUrbanTV from "../components/BarChartUrbanTV";
import AqiDisplay from "../components/AqiDisplay";
import { useDispatch } from "react-redux";
import greenSquare from "../assets/images/greenSquare.png";
import yellowSquare from "../assets/images/yellowSquare.png";
import orangeSquare from "../assets/images/orangeSquare.png";
import redSquare from "../assets/images/redSquare.png";
import purpleSquare from "../assets/images/purpleSquare.png";
import darkredSquare from "../assets/images/darkredSquare.png";
import "chartjs-plugin-datalabels";

import { fetchStationsDaily } from "../store/stationsDaily";
import { fetchStationsHourly } from "../store/stationsHourly";
import { fetchStations } from "../store/stations";
import { fetchInfo } from "../store/information";

const Dispalyer = () => {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(fetchStationsDaily);
    dispatch(fetchStationsHourly);
    dispatch(fetchInfo);
    dispatch(fetchStations);

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Optional: Adds smooth scrolling effect
      });
    };

    // Scroll to the top of the page after navigation when the URL changes
    scrollToTop();
  }, []);
  const [type, setType] = useState("online");
  const { theRouteUrl } = useParams();
  const [selectedType, setSelectedType] = useState("online");
  const stations = useSelector((state) => state.stations);
  const stationsData = stations.stationsData;
  const stationsLoading = stations.stationsLoading;
  const stationsError = stations.stationsError;
  const information = useSelector((state) => state.information);
  const informationData = information.informationData;
  const informationLoading = information.informationLoading;
  const informationError = information.informationError;
  const stationsHourly = useSelector(
    (state) => state.stationsHourly.stationsData
  );
  const stationsDaily = useSelector(
    (state) => state.stationsDaily.stationsData
  );

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const onlineSAPA = stationsData.SAPA;
  const onlineESPS = stationsData.ESPS;
  const onlineOSPM = stationsData.OSPM;
  const onlineSATA = stationsData.SATA;
  const hourlySAPA = stationsHourly.SAPA;
  const hourlyESPS = stationsHourly.ESPS;
  const hourlyOSPM = stationsHourly.OSPM;
  const hourlySATA = stationsHourly.SATA;
  const dailySAPA = stationsDaily.SAPA;
  const dailyESPS = stationsDaily.ESPS;
  const dailyOSPM = stationsDaily.OSPM;
  const dailySATA = stationsDaily.SATA;
  // const onlineKitHava = stationsData.KitHava[0];
  const [onlineStationData, setOnlineStationData] = useState();
  const [hourlyStationData, setHourlyStationData] = useState();
  const [dailyStationData, setDailyStationData] = useState();
  const [theStationData, setTheStationData] = useState(onlineStationData);

  // Fetch data every 15 minutes
  const fetchData = useCallback(() => {
    dispatch(fetchStationsDaily());
    dispatch(fetchStationsHourly());
    dispatch(fetchStations());
    dispatch(fetchInfo());
  }, [dispatch]);

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 900000); // 15 minutes
    return () => clearInterval(intervalId);
  }, [fetchData]);

  const getTheOnlineDataOfTheDevice = () => {
    const informationDataOfTheDevice = informationData.find(
      (element) => element.slug === theRouteUrl
    );

    let onlineStationDataOfTheDevice;
    if (informationDataOfTheDevice.device === "SAPA") {
      onlineStationDataOfTheDevice = onlineSAPA.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "SATA") {
      onlineStationDataOfTheDevice = onlineSATA.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "ESPS") {
      onlineStationDataOfTheDevice = onlineESPS.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "OSPM") {
      onlineStationDataOfTheDevice = onlineOSPM.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    }
    const modifiedOnlineDataOfTheDevice = {
      ...onlineStationDataOfTheDevice,
      ...informationDataOfTheDevice,
    };

    setOnlineStationData(modifiedOnlineDataOfTheDevice);
  };

  const getTheHourlyDataOfTheDevice = () => {
    const informationDataOfTheDevice = informationData.find(
      (element) => element.slug === theRouteUrl
    );

    let hourlyStationDataOfTheDevice;
    if (informationDataOfTheDevice.device === "SAPA") {
      hourlyStationDataOfTheDevice = hourlySAPA.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "SATA") {
      hourlyStationDataOfTheDevice = hourlySATA.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "ESPS") {
      hourlyStationDataOfTheDevice = hourlyESPS.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "OSPM") {
      hourlyStationDataOfTheDevice = hourlyOSPM.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    }

    const modifiedHourlyDataOfTheDevice = {
      ...hourlyStationDataOfTheDevice,
      ...informationDataOfTheDevice,
    };

    setHourlyStationData(modifiedHourlyDataOfTheDevice);
  };

  const getTheDailyDataOfTheDevice = () => {
    const informationDataOfTheDevice = informationData.find(
      (element) => element.slug === theRouteUrl
    );

    let dailyStationDataOfTheDevice;
    if (informationDataOfTheDevice.device === "SAPA") {
      dailyStationDataOfTheDevice = dailySAPA.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "SATA") {
      dailyStationDataOfTheDevice = dailySATA.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "ESPS") {
      dailyStationDataOfTheDevice = dailyESPS.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    } else if (informationDataOfTheDevice.device === "OSPM") {
      dailyStationDataOfTheDevice = dailyOSPM.find(
        (element) => element.device_id === informationDataOfTheDevice.device_id
      );
    }

    const modifiedDailyDataOfTheDevice = {
      ...dailyStationDataOfTheDevice,
      ...informationDataOfTheDevice,
    };

    setDailyStationData(modifiedDailyDataOfTheDevice);
  };

  useEffect(() => {
    const fetchData = async () => {
      // Fetch data only if both stations and information data are loaded
      if (
        !stationsLoading &&
        !informationLoading &&
        !stationsError &&
        !informationError
      ) {
        try {
          await getTheOnlineDataOfTheDevice();
          await getTheHourlyDataOfTheDevice();
          await getTheDailyDataOfTheDevice();

          if (type === "online") {
            setTheStationData(onlineStationData);
          } else if (type === "daily") {
            setTheStationData(dailyStationData);
          }
          setLoading(false); // Set loading state to false
        } catch (error) {
          setError("Error fetching data:", error);
          setLoading(false); // Set loading state to false in case of error
        }
      }
    };

    fetchData(); // Call fetchData function
  }, [
    loading,
    error,
    stationsLoading,
    informationLoading,
    stationsError,
    informationError,
    selectedType,
    type,
    onlineStationData?.AQI,
    dailyStationData?.AQI,
    theStationData?.AQI,
  ]);

  const shouldShowTheWord = (x) => {
    const shouldShow = /^ایستگاه/;
    return !shouldShow.test(x);
  };

  useEffect(() => {
    // Function to toggle between "online" and "daily"
    const toggleType = () => {
      setType((prevType) => (prevType === "online" ? "daily" : "online"));
    };

    // Set interval to toggle type every 1 minute (60000 milliseconds)
    const intervalId = setInterval(toggleType, 45000);

    // Clean up interval on component unmount or if dependencies change
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures effect runs only once on mount

  const convertToJalali = (x) => {
    const A = x.slice(0, 10);
    const B = x.slice(11, 19);
    const C = new Date(A);
    const D = new Intl.DateTimeFormat("fa-IR").format(C);
    const E = D.concat(" ", "(", B, ")");
    return E;
  };

  const navigate = useNavigate();
  const navigateAndFetchData = (theRouteUrl) => {
    const navigateUrl = "/station-data/" + theRouteUrl;
    navigate(navigateUrl);
  };

  const navigateAndFetchSAPAAndKitHavaData = (theRouteUrl) => {
    const navigateUrl = "/station-Data-SATA/" + theRouteUrl;
    navigate(navigateUrl);
  };

  const navigateToCharts = (theRouteUrl) => {
    const navigateUrl = "/station-Charts/" + theRouteUrl;
    navigate(navigateUrl);
  };

  if (loading || stationsLoading || informationLoading) {
    return <IsLoading />;
  }
  if (error || stationsError || informationError) {
    return <HasError />;
  } else if (
    theStationData &&
    theStationData.ccreated_datetime &&
    onlineStationData &&
    onlineStationData.ccreated_datetime
  ) {
    return (
      <div
        className="container-fluid g-0 bg-black d-flex align-items-center overflow-hidden py-0"
        style={{ height: "100vh", width: "100%" }}
      >
        <div
          className="row align-items-center px-2 py-0"
          style={{ height: "100vh", width: "100%" }}
        >
          <div
            className="col-md-2 col-sm-12 bg-black text-bg-light d-flex flex-column d-flex justify-content-center align-items-start py-0"
            style={{ height: "100vh" }}
          >
            <div className="d-flex align-items-center text-white my-3">
              <img
                src={darkredSquare}
                alt="خطرناک"
                style={{ width: "3vw", height: "3vw" }}
              />
              <h5 className="h5 p-2">خطرناک</h5>
            </div>
            <div className="d-flex align-items-center text-white my-3">
              <img
                src={purpleSquare}
                alt="بسیار ناسالم"
                style={{ width: "3vw", height: "3vw" }}
              />
              <h5 className="h5 p-2">بسیار ناسالم</h5>
            </div>
            <div className="d-flex align-items-center text-white my-3">
              <img
                src={redSquare}
                alt="ناسالم"
                style={{ width: "3vw", height: "3vw" }}
              />
              <h5 className="h5 p-2">ناسالم</h5>
            </div>
            <div className="d-flex align-items-center text-white my-2">
              <img
                src={orangeSquare}
                alt="ناسالم برای گروه های حساس"
                style={{ width: "3vw", height: "3vw" }}
              />
              <h5 className="h5 p-2">ناسالم برای گروه های حساس</h5>
            </div>
            <div className="d-flex align-items-center text-white my-3">
              <img
                src={yellowSquare}
                alt="قابل قبول"
                style={{ width: "3vw", height: "3vw" }}
              />
              <h5 className="h5 p-2">قابل قبول</h5>
            </div>
            <div className="d-flex align-items-center text-white mt-3">
              <img
                src={greenSquare}
                alt="پاک"
                style={{ width: "3vw", height: "3vw" }}
              />
              <h5 className="h5 p-2">پاک </h5>
            </div>
          </div>
          <div
            className="col-md-8 col-sm-12 bg-black text-bg-light d-flex align-items-center"
            style={{ height: "100vh" }}
          >
            {theStationData.device === "SATA" ||
            theStationData.device === "SAPA" ? (
              <BarChartUrbanTV
                data={theStationData}
                typeBasedOfTime={type}
                type="gasAndParticles"
              />
            ) : (
              <BarChartUrbanTV
                data={theStationData}
                typeBasedOfTime={type}
                type="onlyParticles"
              />
            )}
          </div>
          <div
            className="col-md-2 col-sm-12 bg-black text-bg-light d-flex align-items-center"
            style={{ height: "100vh" }}
          >
            <table
              className="table table-dark table-striped table-condensed text-center border border-1"
              style={{ width: "100%", maxHeight: "100vh" }}
              dir="rtl"
            >
              <tbody>
                {theStationData.device === "OSPM" &&
                theStationData.device_id === 127 ? (
                  ""
                ) : (
                  <tr>
                    <th
                      className="align-middle IRANSansXE h4 py-5 border border-1"
                      title="اطلاعات هواشناسی - دما"
                    >
                      دما برخط
                    </th>
                    <td
                      className="align-middle IRANSansXB h4 py-5 border border-1"
                      title="اطلاعات هواشناسی - دما"
                    >
                      <p>
                        <sub>℃</sub>
                        {onlineStationData.temperature ? (
                          <span>
                            {Number(onlineStationData.temperature).toFixed(2)}
                          </span>
                        ) : (
                          ""
                        )}
                      </p>
                    </td>
                  </tr>
                )}
                {theStationData.device === "OSPM" &&
                theStationData.device_id === 127 ? (
                  ""
                ) : (
                  <tr>
                    <th
                      className="IRANSansXE h4 py-5 align-middle border border-1"
                      title="اطلاعات هواشناسی - رطوبت موجود در هوا"
                    >
                      رطوبت برخط
                    </th>
                    <td
                      className="IRANSansXB h4 py-5 align-middle border border-1"
                      title="اطلاعات هواشناسی - رطوبت موجود در هوا"
                    >
                      <p>
                        <span>
                          {onlineStationData.humidity ? (
                            <span>
                              {Number(onlineStationData.humidity).toFixed(2)}
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                        <sub>%RH</sub>
                      </p>
                    </td>
                  </tr>
                )}
                <tr>
                  <th className="bold align-middle IRANSansXE h4 py-5 border border-1">
                    آخرین داده
                  </th>
                  {theStationData.ccreated_datetime ? (
                    <td
                      className="align-middle IRANSansXB h4 py-5 border border-1"
                      dir="ltr"
                    >
                      {convertToJalali(theStationData.ccreated_datetime)}
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
                <tr>
                  <th className="bold align-middle IRANSansXE h4 py-5 border border-1">
                    آلاینده عامل
                  </th>
                  <td
                    className="align-middle IRANSansXB h4 py-5 border border-1"
                    title="آلاینده عامل"
                  >
                    {theStationData.mainPollutant}
                  </td>
                </tr>
                {theStationData.device === "SATA" ? (
                  <tr>
                    <th
                      className="IRANSansXE h4 py-5 align-middle border border-1"
                      title="آلودگی ناشی از ترکیبات آلی فرار"
                    >
                      بو
                    </th>
                    <td
                      className="IRANSansXB h4 py-5 align-middle border border-1"
                      title="آلودگی ناشی از ترکیبات آلی فرار"
                    >
                      <p>
                        {onlineStationData.tvoc ? (
                          <span>
                            {Number(onlineStationData.tvoc)?.toFixed(2)}
                          </span>
                        ) : (
                          ""
                        )}
                        <sub>ppm</sub>
                      </p>
                    </td>
                  </tr>
                ) : (
                  ""
                )}
                {theStationData.device === "SATA" ? (
                  <tr>
                    <th
                      className="IRANSansXE h4 py-5 align-middle border border-1"
                      title="میزان آلودگی صوتی"
                    >
                      py-5 صوت
                    </th>
                    <td
                      className="IRANSansXB h4 py-5 align-middle border border-1"
                      title="میزان آلودگی صوتی"
                    >
                      <p>
                        {onlineStationData.spl ? (
                          <span>
                            {Number(onlineStationData.spl).toFixed(2)}
                          </span>
                        ) : (
                          ""
                        )}
                        <sub>dB</sub>
                      </p>
                    </td>
                  </tr>
                ) : (
                  ""
                )}
                {theStationData.device === "OSPM" ||
                theStationData.device === "SAPA" ? (
                  ""
                ) : (
                  <tr>
                    <th
                      className="IRANSansXE h4 py-5 align-middle border border-1"
                      title="اطلاعات هواشناسی - فشار"
                    >
                      فشار
                    </th>
                    <td
                      className="IRANSansXB h4 py-5 align-middle border border-1"
                      title="اطلاعات هواشناسی - فشار"
                    >
                      <p>
                        <span>
                          {onlineStationData.pressure ? (
                            <span>
                              {Number(onlineStationData.pressure)?.toFixed(2)}
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                        <sub>kPa</sub>
                      </p>
                    </td>
                  </tr>
                )}
                {theStationData.device === "SATA" ? (
                  <tr>
                    <th
                      className="IRANSansXE h4 py-5 align-middle border border-1"
                      title="اطلاعات هواشناسی - جهت باد"
                    >
                      جهت باد
                    </th>
                    <td
                      className="IRANSansXB h4 py-5 align-middle border border-1"
                      title="اطلاعات هواشناسی - جهت باد"
                    >
                      <p>
                        <span>{onlineStationData.winddirection}</span>
                        <sub>°</sub>
                      </p>
                    </td>
                  </tr>
                ) : (
                  ""
                )}

                {theStationData.device === "SATA" ? (
                  <tr>
                    <th
                      className="IRANSansXE h4 py-5 align-middle border border-1"
                      title="اطلاعات هواشناسی - سرعت باد"
                    >
                      سرعت باد
                    </th>
                    <td
                      className="IRANSansXB h4 py-5 align-middle border border-1"
                      title="اطلاعات هواشناسی - سرعت باد"
                    >
                      <p>
                        <span>{onlineStationData.windspeed}</span>
                        <sub>m/s</sub>
                      </p>
                    </td>
                  </tr>
                ) : (
                  ""
                )}

                {theStationData.device === "SAPA" &&
                theStationData.device_id === 133 ? (
                  <>
                    <tr>
                      <th
                        className="IRANSansXE h4 py-5 align-middle border border-1"
                        title="آلودگی ناشی از ترکیبات آلی فرار"
                      >
                        بو
                      </th>
                      <td
                        className="IRANSansXB h4 py-5 align-middle border border-1"
                        title="آلودگی ناشی از ترکیبات آلی فرار"
                      >
                        <p>
                          {/* <span>{Number(onlineKitHava.voc)?.toFixed(2)}</span> */}
                          <sub>ppm</sub>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th
                        className="IRANSansXE h4 py-5 align-middle border border-1"
                        title="میزان آلودگی صوتی"
                      >
                        صوت
                      </th>
                      <td
                        className="IRANSansXB h4 py-5 align-middle border border-1"
                        title="میزان آلودگی صوتی"
                      >
                        <p>
                          {/* <span>{Number(onlineKitHava.spl)?.toFixed(2)}</span> */}
                          <sub>dB</sub>
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <th
                        className="IRANSansXE h4 py-5 align-middle border border-1"
                        title="اطلاعات هواشناسی - فشار"
                      >
                        فشار
                      </th>
                      <td
                        className="IRANSansXB h4 py-5 align-middle border border-1"
                        title="اطلاعات هواشناسی - فشار"
                      >
                        <p>
                          <span>
                            {/* {Number(onlineKitHava.pressure)?.toFixed(2)} */}
                          </span>
                          <sub>kPa</sub>
                        </p>
                      </td>
                    </tr>
                  </>
                ) : (
                  ""
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
};
export default Dispalyer;
